<template>
    <div class="h-topo_pw2" v-show="see" :style="PositionXY" style="width:100%; width:300px;height:310px; background:#000000; opacity: 0.70;border-radius:4px;">    
    
    	<div class="topo-title">
          	<i :class="['icon hero-icon hero-icon-topo-subet '+ online +' h-topo_topwz_i']" ></i>
            <label class="topo_title_w200" style="margin: 12px 0 0 2px;" :title='devInfo.name'>{{$t('Topo.subnetName')}}：{{devInfo.name}}</label>
           
        	<a style="cursor:pointer;float: right;margin: 8px 0 0 0;">
	          <span @click="click()" class="e-btn-icon icon hero-icon hero-icon-remove-small"  style="color:#ddd;" :title="$t('Common.close')"></span>
	        </a>       
      	</div>    
      
      	<div class="h-topo_content"  style="padding:10px 10px 0 12px;width: 100%;">	        
          
            <ul class="h-topo_tableheight" style="padding-left: 0px;">  
              <li>{{$t('Topo.subnetID')}}: {{devInfo.id}}</li>
			  <div class="topo-alarm-subnetpanel" :style="styleColorVar" v-if='showAlarmNumBtn'>
				<span>{{$t('Alarm.alarm')}}:</span>   
				<!-- @click="alarmShowOperation"  	 -->
				<a  style="color:dddddd;"><span class="h-icon h-icon-dot critical radius50" ></span>{{Level0AlarmCount}}</a>
				<a  style="color:dddddd;"><span class="h-icon h-icon-dot major radius50"></span>{{Level1AlarmCount}}</a>	      		      		      	
				<a  style="color:dddddd;"><span class="h-icon h-icon-dot minor radius50" ></span>{{Level2AlarmCount}}</a>
				<a  style="color:dddddd;"><span class="h-icon h-icon-dot warning radius50"></span>{{Level3AlarmCount}}</a>
			  </div>
              <li>{{$t('Topo.subnetDes')}}: {{devInfo.description}}</li>           
            </ul>	

				 
				      
       	</div>
 
 		
	</div>
</template>

<script>
import { EventBus } from '../../plugins/eventBus';

	export default {
	  name: "SubnetPanelBoardShow",
	  components: {
	    
	  },
	  data() {
	    return {
			PositionXY: "",
			typeCode: "",
			devInfo: {},
			see: false,
			seeBottom: false,
			id: "",
			type: "",
			online:'',
			nodesMapView:new Map(),
			nodeSubnetList: [],
			Level0AlarmCount: 0,
			Level1AlarmCount: 0,
			Level2AlarmCount: 0,
			Level3AlarmCount: 0,
			showAlarmNumBtn: { type: Boolean, default: true },
			styleColorVar:{},
	    };
	  },
	  props: ["subnetShowObj","roleNe"],
	  methods: {
		  
	    panelBoardGetData() {
	      this.axios
	        .get(`/lte/ems/topo/subnet/findSubnet/${this.id}`)
	        .then(response => {
	          if (response.data.errorCode === 'SUCCESS') {
	            this.devInfo = response.data.resultVal;
	          }
			});
		  this.getNodesSubnet (this.id);
		  this.getAlarmCount();
	    },
	
	    click() {
	      this.seeBottom = !this.seeBottom;
	      this.see = !this.see;
	    },
	
		getNodesSubnet (id){
			this.nodeSubnetList = [];
			this.nodeSubnetList.push(id);
			let childList = new Array();
			childList.push({"id":id})

			while(childList.size>0 || childList.length>0){
				let tt = this.getChild(childList);
				tt.forEach((val, key) => {
					this.nodeSubnetList.push(val.id);
				})
				
				childList = tt;
			}
			
			
		},
		getChild(nodesParentList){
			let childList = new Map();
			nodesParentList.forEach(element =>{
				this.nodesMapView.forEach(temp =>{
					if(element.id == temp.parentid){
						childList.set(temp.id,temp);
					}
				})
			})
			// console.log("getChild",childList);
			return childList;
		},
		getAlarmCount(){
			// console.log("===========roleNe",this.roleNe)
			// console.log("===========nodeSubnetList",this.nodeSubnetList);
			let arr = this.roleNe;
			let arrResult = [];
			let principal = sessionStorage.getItem('principal');
            let user = JSON.parse(principal);
            let userId = user.userId;
			arrResult = this.nodeSubnetList.filter(function(num) {
				return arr.indexOf(parseInt(num)) !== -1;
			});
			this.$axios.post('/lte/ems/fm/alarmcurrent/alarmCount', {
				conditions: "",
				keywords: "",
				roleNe: arrResult,
				userId:userId
			}).then((response) => {
				if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
				// This.updateCount(response.data.resultVal.alarmCountInfo);
					// console.log(response.data.resultVal.alarmCountInfo)
					this.Level0AlarmCount = response.data.resultVal.alarmCountInfo.criticalAlarmCount;
					this.Level1AlarmCount = response.data.resultVal.alarmCountInfo.majorAlarmCount;
					this.Level2AlarmCount = response.data.resultVal.alarmCountInfo.minorAlarmCount;
					this.Level3AlarmCount = response.data.resultVal.alarmCountInfo.warningAlarmCount;
				}
			});
		},
		queryTopoConfig(){
			const url = "";
			this.axios.get(`/lte/ems/sysmanager/systemtopoconfig/querySystemTopoConfig`).then(response => {
				if (response && response.status === 200) {
					if(0==response.data.resultVal[0].alarmNumSet){
						this.showAlarmNumBtn = false;
					}else{
						this.showAlarmNumBtn = true;
						// this.$refs.baseBtn.queryAlarmNum();
					}
				}
			})
		}
	  },
	
	  mounted() {

		EventBus.$on('nodesMapView', target => {
		//   console.log("subnetPanel nodesMapView",target)
		  this.nodesMapView = target;
		  
		});
		this.styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));
		this.queryTopoConfig();
	  },
	  watch: {
	    //父子动态传值
	    subnetShowObj: {
	      handler: function(newVal, oldVal) {
		        this.see = newVal.seeObj;
		        this.seeBottom = newVal.seeBottomObj;
		        
		        var changed = ( this.id != newVal.idObj)?true:false;
		        this.id = newVal.idObj;
		        if(newVal.onlineObj===1){
		         	this.online='h-pm-iconOnline';
		        }       
		        else if(newVal.onlineObj===0){
		         	this.online='h-pm-iconOffline';
		        }
		        this.PositionXY = newVal.PositionXY;
		        if(this.see == true)
		        {
		        	  this.panelBoardGetData();
		        }
		      
		                
	      },
	      deep: true
		}
		
	  }
	};
	</script>
<style>
.topo-title a:hover
{
	text-decoration: none;
}
div.topo-alarm-subnetpanel
{
	float: left;
    width: 100%;
    padding: 0 0 10px 0px;
    color: #dddddd;
}

.topo-alarm-subnetpanel a
{
	margin: 0 10px 0 10px;
	color: #dddddd;
	/* cursor: pointer; */
	text-decoration: underline;
}

.topo-alarm-subnetpanel .radius50
{
	width: 10px !important;
    height: 10px !important;
    border-radius: 50%;
}
</style>
